/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';

const namespace = 'textToSpeech';

export default {
  namespace,
  state: Immutable({
    textAudioSrc: '',
    saveSelection: null,
    customPauseTone: 0,
    showPinyinFeedBack: false, // 是否展示拼音问题反馈弹框
    importFile: null,
    categoryCodes: null //模板的一级二级code
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    updateAudioSrc: function(src) {
      return {
        type: namespace + '/update/textAudioSrc',
        field: 'textAudioSrc',
        data: src
      };
    },
    updateSaveSelection: function(data) {
      return {
        type: namespace + '/update/saveSelection',
        field: 'saveSelection',
        data
      };
    },
    updateCustomPauseTone: function(data) {
      return {
        type: namespace + '/update/customPauseTone',
        field: 'customPauseTone',
        data
      };
    },
    updateShowPinyinFeedBack: function(data) {
      return {
        type: namespace + '/update/showPinyinFeedBack',
        field: 'showPinyinFeedBack',
        data
      };
    },
    updateImportFile: function(data) {
      localStorage.setItem('importFile', JSON.stringify(data));
      return {
        type: namespace + '/update/importFile',
        field: 'importFile',
        data
      };
    },
    updateCategoryCodes: function(data) {
      return {
        type: namespace + '/update/categoryCodes',
        field: 'categoryCodes',
        data
      };
    }
  }
};
